<div #sendNotificationDialog>
    <mat-dialog-content class="">
        <h3>{{data.title | uppercase }}</h3>
        <p [innerHTML]="data.titleBody"></p>
        <p class="warning" *ngIf="data.warning">{{data.warning}}</p>
        <p [innerHTML]="data.body"></p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>NO</button>
        <button mat-button [mat-dialog-close]="true" cdkFocusInitial>YES</button>
    </mat-dialog-actions>
</div>